import React, { useEffect, useState } from "react";
import PreviousDataBox from "./PreviousDataBox";
import Transaction from "../../../API/APIServices/Transaction";
import TemplateSetting from "../../../API/APIServices/TemplateSetting";

const PreviousData = (props) => {
  const {
    isSliderOpen,
    openPreviousDataList,
    setLoading,
    InputValueAccMaster,
    GetcolName,
    setRegularLens,
    handleLAddRLeave,
    handleLAddLLeave,
    setIssavingLens
  } = props;
  const [myOrderdata, setMyOrderData] = useState([]);
  const [lensItems, setLensItems] = useState([]);
  useEffect(() => {
    const lensItems = myOrderdata.filter((item) => item.LinkedItm != "0");
    setLensItems(lensItems);
  }, [myOrderdata]);

  const [lensData, setLensData] = useState();
  let Count = 0;
  const fetchMyOrderData = async (pageNumber) => {
    ;

    try {
      if (InputValueAccMaster) {
        // const data = await Transaction.getAccountOrder(
        //   InputValueAccMaster.AccId,
        //   pageNumber
        // );

        try {
          const templateSettingFilter = [
            {
              fieldName: "reportAttachTo",
              operatorName: "Equal",
              compareValue: "323",
            },
          ];

          const templateSettingResponse =
            await TemplateSetting.getTemplateSettingFilter(
              templateSettingFilter
            );
          if (templateSettingResponse) {
            const queryData =
              templateSettingResponse[0]?.templateSettingDTO.queryForSql || "";
            const ReportType =
              templateSettingResponse[0].templateSettingDTO.reportType || 0;
            if (!queryData) return;
            try {
              const filterData = [
                {
                  fieldName: GetcolName("PartyId", queryData),
                  operatorName: "equal",
                  compareValue: InputValueAccMaster.AccId,
                },
              ];

              setLoading(true);
              const AllData =
                await TemplateSetting.getDatasetExecuteQueryFilter_Ledger(
                  queryData,
                  filterData,
                  1,
                  10000,
                  ReportType
                );

              var data = AllData.table;
              console.log(data);
              if (data && data.length > 0) {
                // //;
                // const filteredData = data.filter((item) => item.RecoType == 4);
                setMyOrderData(data);
              }
            } catch (error) {
              console.log("Error when fetching item stock!", error);
            }
          }
        } catch {}
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (myOrderdata && myOrderdata.length === 0 && Count === 0) {
      Count += 1;
      //;
      if (isSliderOpen == true) {
        fetchMyOrderData();
      }
    }
  }, [isSliderOpen]);

  return (
    <div>
      <div className={`slider-container-Bottom ${isSliderOpen ? "open" : ""}`}>
        <div style={{ position: "relative" }}>
          <div
            onClick={() => openPreviousDataList()}
            className="xmark-ms-2 for-slider"
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <p className="slider-p">Previous Record</p>
        {myOrderdata && myOrderdata[1] && (
          <div className="slider-databox-top">
            <span>
              Total Business :- {myOrderdata[1]?.totalProductValue?.toFixed(2) || 0}
            </span>
            <span>
              Total Balance :- {myOrderdata[1]?.totalBalance?.toFixed(2) || 0}
            </span>
            <span>
              Total Discount :- {myOrderdata[1]?.totalDiscount?.toFixed(2) || 0}
            </span>
            <span>
              Loyalty Point :- {myOrderdata[1]?.loyaltyPoint?.toFixed(2) || 0}
            </span>
            <span>
              Sale Return :- {myOrderdata[1]?.saleReturn?.toFixed(2) || 0}
            </span>
          </div>
        )}

        <div className="slider-databox">
          <PreviousDataBox
            myOrderdata={myOrderdata}
            lensItems={lensItems}
            setRegularLens={setRegularLens}
            handleLAddRLeave={handleLAddRLeave}
            handleLAddLLeave={handleLAddLLeave}
            openPreviousDataList={openPreviousDataList}
            setIssavingLens={setIssavingLens}
          />
        </div>
      </div>
    </div>
  );
};

export default PreviousData;
